import {
    AlertIcon,
    CalendarIcon,
    LawIcon,
    PencilIcon,
    RowsIcon,
    StackIcon,
    StopIcon
} from "@primer/octicons-react";
import { Box, Flash, IconButton, Octicon } from '@primer/react';
import { useEffect, useState } from "react";
import Moment from 'react-moment';
import { useDispatch, useSelector } from 'react-redux';
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import UserAvatar from "../../../components/user-avatar";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { IHocSinhViewModel } from "../../../models/response/category/IHocSinhViewModel";
import { thuPhiTabAction } from "../../../state/actions/thu-phi-tab/thuPhiTabAction";
import { IThuPhiTabReducer } from "../../../state/page-state-model/IThuPhiTabReducer";
import { RootState } from '../../../state/reducers';

interface IHocSinhShortInfoProps {
    hocSinh?: IHocSinhViewModel,
    selectedTab: IThuPhiTabReducer
}
const HocSinhShortInfo = (props: IHocSinhShortInfoProps) => {
    const { hocSinh } = props;
    const { nam_hoc } = useSelector((x: RootState) => x.common);
    const [tong_tien_thua, set_tong_tien_thua] = useState<any>(0);
    const dispatch = useDispatch();

    const handleReloadTienThuaHocSinh = async () => {
        if (hocSinh) {
            const datasend: sf_mucphaithu_select_byhocsinh_rq = { ts_hocsinh_id: hocSinh.id, nam_hoc: nam_hoc }
            const res = await mucPhaiThuApi.select_tienthua_by_hocsinh(datasend);
            if (res.is_success && res.data && res.data.tong_tien_thua != undefined) {
                set_tong_tien_thua(res.data.tong_tien_thua)
            }
        }
    }
    useEffect(() => {
        if (hocSinh && nam_hoc) {
            handleReloadTienThuaHocSinh();
        }
    }, [hocSinh, nam_hoc])
    return (
        <Box sx={{ width: "100%"}}>
            {!hocSinh &&
                <Box sx={{ pl:1 }}>
                    <Flash sx={{ mt: 2 }} variant='warning'>
                        <Box>
                            <Octicon icon={AlertIcon} />
                            Chọn học sinh từ danh sách để bắt đầu thu phí
                        </Box>
                    </Flash>
                </Box>
            }
            {hocSinh &&
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', pl:2 }}>
                        <Box sx={{ width: 30, pt: 2 }}>
                            <UserAvatar fullName={hocSinh?.ho_ten} size="large" />
                        </Box>
                        <Box
                            style={{
                                display: "grid",
                                marginLeft: "10px",
                                justifyContent: "flex-start",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <span style={{ fontWeight: "600", fontSize: 17 }}>{hocSinh?.ho_ten}</span>
                            </div>
                            <span style={{ fontWeight: "400", fontSize: 12 }}>{hocSinh?.ma_hs}</span>

                        </Box>
                        <Box
                            style={{
                                marginLeft: "30px",
                                display: "grid",
                                gridTemplateColumns: "200px 80px 120px 80px 90px",
                                gap: "10px",
                                textAlign: "left",
                                justifyContent: "flex-start",
                            }}
                        >
                            <span style={{ fontWeight: "350", fontSize: 12 }}>Tên trường</span>
                            <span style={{ fontWeight: "350", fontSize: 12 }}>Tên khối</span>
                            <span style={{ fontWeight: "350", fontSize: 12 }}>Tên hệ</span>
                            <span style={{ fontWeight: "350", fontSize: 12 }}>Tên lớp</span>
                            <span style={{ fontWeight: "350", fontSize: 12 }}>Số tiền khả dụng</span>


                            <span style={{ fontWeight: "600" }}>{hocSinh?.ten_truong}</span>
                            <span style={{ fontWeight: "600" }}>{hocSinh?.ten_khoi}</span>
                            <span style={{ fontWeight: "600" }}>{hocSinh?.ten_he}</span>
                            <span style={{ fontWeight: "600" }}>{hocSinh?.ten_lop}</span>
                            <span style={{ fontWeight: "600", textAlign:'right' }}> {tong_tien_thua.toLocaleString()} <sup>đ</sup></span>
                        </Box>
                    </Box>

                </Box>
            }
        </Box >



    );
};

export default HocSinhShortInfo;